<template>
  <div class="app-container" id="djlUpload">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="90px"
      >
        <el-form-item label="分公司：" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="listQuery.bmbh"
            placeholder="全部"
            clearable
            filterable
            multiple
            :disabled="bmbh_disabled"
            collapse-tags
            size="small"
            style="width: 280px"
            class="filter-item"
            @change="handleChangeBm"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目名称：" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="listQuery.xmbh"
            placeholder="全部"
            clearable
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 280px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="统计月份：" prop="tjyf">
          <el-date-picker
            ref="tjyf"
            v-model="listQuery.tjyf"
            type="months"
            size="small"
            placeholder="选择统计月份"
            value-format="yyyyMM"
            style="width: 280px"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="行员类型：" prop="hylx">
          <el-select
            ref="hylx"
            v-model="listQuery.hylx"
            placeholder="全部"
            clearable
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 280px"
            class="filter-item"
          >
            <el-option
              v-for="item in hylxList"
              :key="item.dictLabel"
              :label="item.dictLabel"
              :value="item.dictLabel"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="来源类型：" prop="lylx">
          <el-select
            ref="lylx"
            v-model="listQuery.lylx"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 280px"
            class="filter-item"
          >
            <el-option
              v-for="item in lylxList"
              :key="item.lable"
              :label="item.lable"
              :value="item.lable"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="录入人：" prop="lrr">
          <treeselect
            v-model="listQuery.lrr"
            :multiple="true"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="false"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 280px; line-height: 18px; margin-top: 2px"
            :limit="1"
            size="small"
          />
        </el-form-item>
        <el-form-item label="功能名称：" prop="gnmc">
          <el-input
            v-model="listQuery.gnmc"
            clearable
            size="small"
            style="width: 280px"
            class="filter-item"
          />
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >查询</el-button
          >

          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            style="margin-left: 15px"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="序号"
          align="center"
          prop="xh"
          min-width="50px"
          :show-overflow-tooltip="true"
          fixed
          header-align="center"
        />
        <el-table-column
          label="分公司"
          align="center"
          prop="bmmc"
          min-width="150px"
          :show-overflow-tooltip="true"
          fixed
          header-align="center"
        />
        <el-table-column
          label="项目名称"
          align="center"
          prop="xmmc"
          min-width="200px"
          :show-overflow-tooltip="true"
          fixed
          header-align="center"
        />
        <el-table-column
          label="统计月份"
          align="center"
          prop="tjyf"
          min-width="100px"
          :show-overflow-tooltip="true"
          fixed
          header-align="center"
        />
        <el-table-column
          label="行员类型"
          align="center"
          prop="hylx"
          min-width="100px"
          :show-overflow-tooltip="true"
          header-align="center"
        />
        <el-table-column
          label="功能编号"
          align="center"
          prop="gnbh"
          min-width="100px"
          :show-overflow-tooltip="true"
          header-align="center"
        />
        <el-table-column
          label="功能名称"
          align="center"
          prop="gnmc"
          min-width="150px"
          :show-overflow-tooltip="true"
          header-align="center"
        />
        <el-table-column
          label="点击次数"
          align="right"
          prop="djcs"
          min-width="100px"
          :show-overflow-tooltip="true"
          header-align="center"
        />
        <el-table-column
          label="功能使用人数"
          align="right"
          prop="gnsyrs"
          min-width="120px"
          :show-overflow-tooltip="true"
          header-align="center"
        />
        <!-- <el-table-column
          label="活跃用户数"
          align="right"
          prop="hyyhs"
          min-width="100px"
          :show-overflow-tooltip="true"
          header-align="center"
        />
        <el-table-column
          label="使用人数占比"
          align="right"
          prop="syrszb"
          min-width="120px"
          :show-overflow-tooltip="true"
          header-align="center"
        /> -->
        <el-table-column
          label="来源类型"
          align="center"
          prop="lylx"
          min-width="100px"
          :show-overflow-tooltip="true"
          header-align="center"
        />
        <el-table-column
          label="录入人"
          align="center"
          prop="lrr"
          min-width="100px"
          :show-overflow-tooltip="true"
          header-align="center"
        />
        <el-table-column
          label="录入时间"
          align="center"
          prop="lrsj"
          min-width="150px"
          :show-overflow-tooltip="true"
          header-align="center"
        />
      </el-table>
      <pagination
        v-if="!is_upload"
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Treeselect from "@riophae/vue-treeselect";
import moment from "moment";
import "moment/locale/zh-cn";
import { getBmxxList, getXmxxList } from "@/api/itWeekly";
import { getKeyValue } from "@/api/taskType.js";
import { djlList, djlExport, fetchHylx } from "@/api/jxcp.js";
export default {
  // 列表分页
  components: {
    Pagination,
    Treeselect,
  },

  data() {
    return {
      action: window.g.apiUrl + "pmp/jxcp/gndjlUpload",
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      data2: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "DS,MC,PX,RW,SD,SW,TS,DS,SW,YP", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "1", //合同状态，多个,隔开，如1,3
      },
      height: 100,
      listQuery: {
        bmbh: [],
        xmbh: [],
        tjyf: [],
        lylx: "",
        hylx: [],
        gnmc: "",
        lrr: null,
        page: 1,
        pageSize: 10,
      },
      listLoading: false,
      total: 0,
      list: [],
      bmList: [],
      xmList: [],
      fileList: [],
      lylxList: [
        { value: 1, lable: "PC端" },
        { value: 2, lable: "移动端" },
      ],
      hylxList: [],
      is_upload: false,
      scqk: null,
      bmbh_disabled: false,
    };
  },
  computed: {
    ...mapGetters(["deptUser", "user", "task"]),
  },
  created() {
    this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
      this.initData();
    });
    getBmxxList(this.data2.type, this.data2.range).then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    // getXmxxList(
    //   this.data2.htlx,
    //   this.data2.range,
    //   this.data2.htzt,
    //   "",
    //   ""
    // ).then((res) => {
    //   if (res.code == 0) {
    //     this.xmList = res.data;
    //   }
    // });

    fetchHylx().then((res) => {
      if (res.code === 0) {
        this.hylxList = res.data;
      }
    });
  },

  methods: {
    getList() {
      let lrr = null;
      lrr = this.listQuery.lrr ? this.listQuery.lrr.join(",") : null;
      const bmbh = this.listQuery.bmbh ? this.listQuery.bmbh.join(",") : "";
      const xmbh = this.listQuery.xmbh ? this.listQuery.xmbh.join(",") : "";
      const tjyf = this.listQuery.tjyf ? this.listQuery.tjyf.join(",") : "";
      const hylx = this.listQuery.hylx ? this.listQuery.hylx.join(",") : "";
      const query = { ...this.listQuery, bmbh, xmbh, tjyf, hylx, lrr };
      djlList(query).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 35;
        }
      });
    },

    handleChangeBm(i) {
      const bmbh = this.listQuery.bmbh.join(",");
      getXmxxList(
        this.data2.htlx,
        this.data2.range,
        this.data2.htzt,
        bmbh,
        "1,2,3"
      ).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
        }
      });
    },

    //导出
    handleExport() {
      let lrr = null;
      lrr = this.listQuery.lrr ? this.listQuery.lrr.join(",") : null;
      const gnmc = this.listQuery.gnmc;
      const lylx = this.listQuery.lylx;
      const bmbh = this.listQuery.bmbh ? this.listQuery.bmbh.join(",") : "";
      const xmbh = this.listQuery.xmbh ? this.listQuery.xmbh.join(",") : "";
      const tjyf = this.listQuery.tjyf ? this.listQuery.tjyf.join(",") : "";
      const hylx = this.listQuery.hylx ? this.listQuery.hylx.join(",") : "";
      const query = { bmbh, xmbh, tjyf, gnmc, hylx, lylx, lrr };
      djlExport(query).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    initData() {
      if (this.user.jxcpAdmin == 0) {
        this.listQuery.bmbh.push(this.user.bmbh);
        this.bmbh_disabled = true;
      }
      this.handleChangeBm();
      this.getList();
    },

    // 重置
    reset() {
      this.listQuery = {
        ...this.listQuery,
        ...{
          bmbh: null,
          xmbh: null,
          hylx: null,
          lylx: null,
          gnmc: null,
          tjyf: null,
        },
      };
    },
  },
};
</script>
<style lang="less" scoped>
.vue-treeselect {
  line-height: 18px;
}
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.red {
  color: #ff0000 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey {
  color: #606266 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey2 {
  color: #999 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}

.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.row {
  margin-top: 15px;
  .title {
    height: 44px;
    background-color: #d7d7d7;
    padding-left: 15px;
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 15px;
  }
  .step-wrap {
    padding: 0 10%;
  }
  .apply-info {
    display: flex;
    height: 44px;
    line-height: 44px;
    .item {
      padding: 0 50px;
    }
    div {
      display: flex;
    }
  }
}
.myRadio {
  margin-right: 5px;
}
.gray {
  background-color: #ddd;
  border-color: #ddd;
}
.upload {
  margin-left: 5px;
}
</style>
